// @vue/component
export default {
  name: 'ReportsFormExportItemNumber',

  props: {
    currentField: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fieldValue: this.currentField.default_value,
    };
  },
};
